<template>
  <span class="desc-info">
    <template v-for="(genre, index) in genreList" >
       <span :key="index">{{genre.text}}</span>
       <i v-if="index < genreList.length - 1" :key="'genre_' + index" class="icon-dotted"></i>
    </template>
  </span>
</template>
<script>
import { get } from 'lodash'
export default {
  name: 'MovieGenre',
  props: ['contentInfo'],
  computed: {
    targetage () {
      const age = get(this.contentInfo, 'targetage', '')
      if (age !== '') {
        if (Number(age) < 20) {
          return age === '0' ? '전체' : `${age}세`
        } else {
          return '청불'
        }
      } else {
        return ''
      }
    },
    genreList () {
      let list = []
      const { rating = '0', genre, playtime = '0' } = this.contentInfo
      const genreItem = get(genre, 'list.0', {})
      const genreText = get(genreItem, 'text', '')
      const genreValue = get(genreItem, 'value', '').toUpperCase()
      if (rating !== '0') {
        list.push({ text: `평점 ${rating}` })
      }
      if (genreText !== '' && genreValue !== 'MGM14') {
        list.push({ text: genreText })
      }
      if (playtime !== '0') {
        list.push({ text: `${Math.floor(Number(playtime) / 60)}분` })
      }
      if (this.targetage !== '') {
        list.push({ text: this.targetage })
      }
      return list
    }
  }
}
</script>
